import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useNotifications } from '@/shared/contexts/NotificationContext.new';

export function useRecordingNotifications() {
  const { addNotification } = useNotifications();

  useEffect(() => {
    // Check if user is authenticated before subscribing
    const setupSubscription = async () => {
      // CRITICAL FIX: Use localStorage instead of getSession() to prevent hanging
      const { hasSession } = await import('@/shared/utils/supabaseStorage');

      if (!hasSession()) {
        // Silent for public/guest users - prevents console spam
        return null;
      }

      // DISABLED: Backend now handles all recording notifications via Socket.IO
      // This prevents duplicate notifications for guest recordings
      console.log('[notifications] Recording notifications are now handled by backend via Socket.IO');

      // Return null to disable the subscription
      return null;
    };

    let channelPromise = setupSubscription();

    return () => {
      channelPromise.then(channel => {
        if (channel) {
          try {
            supabase.removeChannel(channel);
          } catch {}
        }
      });
    };
  }, [addNotification]);
}